/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MinusIcon16Light } from './MinusIcon16Light';
import { MinusIcon16Regular } from './MinusIcon16Regular';
import { MinusIcon16Solid } from './MinusIcon16Solid';
import { MinusIcon20Light } from './MinusIcon20Light';
import { MinusIcon20Regular } from './MinusIcon20Regular';
import { MinusIcon20Solid } from './MinusIcon20Solid';
import { MinusIcon24Regular } from './MinusIcon24Regular';
import { MinusIcon24Solid } from './MinusIcon24Solid';
import { MinusIcon32Regular } from './MinusIcon32Regular';
import { MinusIcon64Regular } from './MinusIcon64Regular';
var sizes = {
    16: {
        light: MinusIcon16Light,
        regular: MinusIcon16Regular,
        solid: MinusIcon16Solid,
    },
    20: {
        light: MinusIcon20Light,
        regular: MinusIcon20Regular,
        solid: MinusIcon20Solid,
    },
    24: {
        regular: MinusIcon24Regular,
        solid: MinusIcon24Solid,
    },
    32: {
        regular: MinusIcon32Regular,
    },
    64: {
        regular: MinusIcon64Regular,
    },
};
export var MinusIcon = forwardRef('MinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
